import {
  EuiButton,
  EuiLink,
  EuiEmptyPrompt,
  EuiTitle,
  EuiImage,
} from "@inscopix/ideas-eui";
import { useRouteMapContext } from "providers/RouteMapProvider/RouteMapProvider";
import { useTenantContext } from "providers/TenantProvider/TenantProvider";
import illustration from "assets/toolillustration.svg";
import { useToolDataContext } from "pages/tool/ToolDataProvider";
import { createToolVersionDraft } from "components/ToolEditor/api/createToolVersionDraft";
import { addUtilityToastFailure } from "utils/addUtilityToastFailure";

/*
 * Tool page body panel prompting user to start editing the first draft
 */
export const ToolPanelCreateFirstDraft = () => {
  const { tool } = useToolDataContext();
  const routeMap = useRouteMapContext((s) => s.routeMap);
  const currentTenant = useTenantContext((s) => s.currentTenant);

  const handleCreate = async () => {
    try {
      const res = await createToolVersionDraft({ tool: tool.id });

      routeMap.TOOL_EDITOR.dynamicPath({
        tenantKey: currentTenant.key,
        toolId: tool.id,
        toolVersionId: res.data.tool_version.id,
      }).navigateTo();
    } catch (err) {
      addUtilityToastFailure("Failed to create draft");
    }
  };

  return (
    <EuiEmptyPrompt
      icon={<EuiImage size="fullWidth" src={illustration} alt="" />}
      hasBorder={true}
      layout="horizontal"
      title={<h3>Publish your first tool version</h3>}
      body={
        <p>
          This tool does not have any published versions yet. Click the button
          below to start your first draft, where you can upload your code,
          configure the analysis table, run tests, and publish your first
          version for use within your organization.
        </p>
      }
      actions={
        <EuiButton color="primary" fill onClick={() => void handleCreate()}>
          Start Draft
        </EuiButton>
      }
      footer={
        <>
          <EuiTitle size="xxs">
            <h3>Want to learn more?</h3>
          </EuiTitle>
          {
            // @TODO add documentation link for custom tools
          }
          <EuiLink href="#" target="_blank">
            Read the docs
          </EuiLink>
        </>
      }
    />
  );
};
